import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from './auth.service';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router/src/router_state';
import {Observable} from 'rxjs';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(public auth: AuthService, public router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const routeUrl = route.routeConfig.path;

    if (!this.auth.isAuthenticated()) {
      if (routeUrl !== '' && routeUrl !== 'login') {
        console.error('Login before access');
      }

      if (routeUrl !== 'login') {
        this.router.navigate(['login']);
      } else {
        return true;
      }
    }

    if (routeUrl === 'login') {
      this.router.navigate(['contractual-data']);
    }

    return true;
  }
}
